"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.denormalizeDecimals = exports.normalizeDecimals = void 0;
var bn_js_1 = __importDefault(require("bn.js"));
var DEFAULT_DECIMALS = 18;
// Takes a denormalized value with less decimals (9) and transforms into normalized 18 decimals.
// For example: 9 -> 18
function normalizeDecimals(value, decimals) {
    if (decimals === DEFAULT_DECIMALS) {
        return value;
    }
    var diff = new bn_js_1.default(10).pow(new bn_js_1.default(DEFAULT_DECIMALS - decimals));
    return value.mul(diff);
}
exports.normalizeDecimals = normalizeDecimals;
// Takes a normalized value with more decimals (18) and transforms into token-specific decimals.
// For example: 18 -> 9
function denormalizeDecimals(value, decimals) {
    if (decimals === DEFAULT_DECIMALS) {
        return value;
    }
    var diff = new bn_js_1.default(10).pow(new bn_js_1.default(DEFAULT_DECIMALS - decimals));
    return value.div(diff);
}
exports.denormalizeDecimals = denormalizeDecimals;
